import styledComponents from 'styled-components'

export const Level = styledComponents.nav.attrs({ className: 'level' })``
export const LevelLeft = styledComponents.div.attrs({
  className: 'level-left',
})``
export const LevelRight = styledComponents.div.attrs({
  className: 'level-right',
})``
export const LevelItem = styledComponents.div.attrs({
  className: 'level-item',
})``



// WEBPACK FOOTER //
// ./src/components/views/layouts/Level.js